import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    visitorId: null,
    lang: null,
    showLoadindicator: true,
    dataLoadError: null,
    cmsData: null,
    currentStep: 1,
    stationStartTimestamp: null,
    stationEndTimestamp: null,
    clickCount: 0,
    wrongAnswered: 0,
    correctAnswered: 0,
    screenState: 'quiz',
    sendStatisticsLoading: false,
    sendStatisticsSuccess: null,
    sendStatisticsError: null,
    lastHttpAction: null,
  },
  actions,
  getters,
  mutations,
});